import { FC } from 'react';

type Props = {
	className?: string;
};

const StatusActiveIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#EAEAEA'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.33301 10C2.33301 14.4183 5.91473 18 10.333 18C14.7513 18 18.333 14.4183 18.333 10C18.333 5.58172 14.7513 2 10.333 2C5.91473 2 2.33301 5.58172 2.33301 10ZM13.8126 7.21886C14.1156 7.49659 14.136 7.96734 13.8584 8.27031L9.76534 12.7354C9.62811 12.8851 9.43582 12.9721 9.23288 12.9766C9.02994 12.981 8.83404 12.9023 8.69051 12.7588L6.83004 10.8983C6.53942 10.6077 6.53942 10.1365 6.83004 9.84588C7.12067 9.55527 7.59186 9.55527 7.88249 9.84588L9.19336 11.1568L12.7611 7.26458C13.0389 6.96161 13.5096 6.94114 13.8126 7.21886Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default StatusActiveIcon;
